import { useVideoDownlinkPolicy } from "../hooks/useVideoDownlinkPolicy";
import { useDeviceHotPlug } from "../hooks/useDeviceHotPlug";

export function VideoTileGridEffects() {
  useVideoDownlinkPolicy();
  useDeviceHotPlug();
  return null;
}
